export function logAuthSuccess(logger, params) {
    logger.info('Authentication success', {
        eventCategory: 'authentication',
        provider: params.provider,
        userId: params.userId,
    });
}
export function logAuthTokenRefreshFailure(logger, params) {
    logger.warn('Auth token refresh failure', {
        eventCategory: 'authentication',
        provider: params.provider,
        reason: params.reason,
    });
}
export function logAuthLogout(logger, params) {
    logger.info('Authentication logout', {
        eventCategory: 'authentication',
        provider: params.provider,
    });
}
